module.exports = __webpack_public_path__ + "static/media/tjb.7dde9df9.png";